export default "__VITE_ASSET__CMw9YsMu__"